import type {
  ExtendedThalamosUser,
  TermsAndConditions,
} from "@thalamos/aspire-common";

export function termsAndConditionsNeedingAcceptanceByUser(
  user: ExtendedThalamosUser,
): Pick<TermsAndConditions, "id" | "humanReadableName" | "type"> | null {
  const requiredTermsAndConditions =
    user.sessionOrganisationConfiguration?.termsAndConditions;

  const alreadyAcceptedTermsAndConditions =
    user.termsAndConditionsAcceptances.some(
      (t) => t.id === requiredTermsAndConditions?.id,
    );

  const needsToAcceptTermsAndConditions =
    requiredTermsAndConditions && !alreadyAcceptedTermsAndConditions;

  return needsToAcceptTermsAndConditions ? requiredTermsAndConditions : null;
}
